import * as React from 'react';
import { classes } from '../../HamburgerMenuContainer.component.st.css';
import type { IHamburgerMenuContainerProps } from '../../../HamburgerMenuContainer.props';
import HamburgerMenuContainerCommon from '../../HamburgerMenuContainer';
import clsx from 'clsx';
import { useHamburgerMenuContext } from '../../../../HamburgerMenuContext';

const DefaultSkin: React.FC<IHamburgerMenuContainerProps> = props => {
  const { stylableClassName } = props;

  const { isMenuContainerFullscreen = false } = useHamburgerMenuContext();

  return (
    <HamburgerMenuContainerCommon
      {...props}
      rootClassName={clsx(
        classes.root,
        isMenuContainerFullscreen ? '' : stylableClassName,
      )}
    />
  );
};

export default DefaultSkin;
